import { useTranslation } from 'react-i18next';

import { useTheme } from '@platform/core/theme';

import { MenuItemCheckbox } from './menu-item-checkbox';

const modes = ['light', 'dark'] as const;
export type ThemeMode = (typeof modes)[number];

export const ThemeMenuItems = ({
  handleCloseMenu,
}: {
  handleCloseMenu: () => void;
}) => {
  const { t } = useTranslation('app', { keyPrefix: 'appBar.settingsMenu' });
  const [theme, setTheme] = useTheme();

  const handleOnClick = (mode: ThemeMode) => {
    setTheme(mode);
    handleCloseMenu();
  };

  return (
    <>
      {modes.map((mode) => (
        <MenuItemCheckbox
          key={mode}
          label={t(`mode.${mode}`)}
          selected={theme === mode}
          onClick={() => handleOnClick(mode)}
        />
      ))}
    </>
  );
};
